import React from 'react'
import { Col, Row } from 'antd'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../../../store/selectors/assignment.selectors'
import { ASSIGNMENT_TYPES } from '../../../../../../constants/assignment-types'
import GradesHistogramCard from './grades-histogram/GradesHistogramCard'
import AttemptsHistogramCard from './attempts-histogram/AttemptsHistogramCard'
import GroupsPieCard from './groups-pie/GroupsPieCard'
import UnitTestsHistogramCard from './unit-tests/UnitTestsHistogramCard'

const CsAnalyticsReportSection = () => {
    const assignmentType = useSelector(assignmentSelectors.type)
    const assignmentHasUnitTests = useSelector(assignmentSelectors.hasUnitTests)

    return (
        <>
            <Row gutter={16}>
                <Col xl={assignmentType === ASSIGNMENT_TYPES.MODEL.value ? 24 : 15} md={24} className='mb-16'>
                    <GradesHistogramCard />
                </Col>
                {assignmentType !== ASSIGNMENT_TYPES.MODEL.value && (
                    <Col xl={9} md={24} className='mb-16'>
                        <AttemptsHistogramCard />
                    </Col>
                )}
            </Row>
            <Row gutter={16} className='mb-16'>
                <Col span={24}>
                    <GroupsPieCard />
                </Col>
            </Row>
            {assignmentHasUnitTests && (
                <Row gutter={16}>
                    <Col span={16}>
                        <UnitTestsHistogramCard />
                    </Col>
                </Row>
            )}
        </>
    )
}

export default CsAnalyticsReportSection
